export default __webpack_public_path__ + "media/images/paylogos/color/dotpay-f418817fe709c64cafcf95b9bf032f92.png";